import { segment } from '@actions/analytics';
import useCreateReferralMessage from '@hooks/useCreateReferralMessage';
import useGetReferralInfo from '@hooks/useGetReferralInfo';
import useOneLinkReferral from '@hooks/useOneLinkReferral';
import socialShare from '@utils/socialShare';
import { useCallback, useState } from 'react';
import { REFER_CODE_SHARED } from '../constants';

const useReferralSharing = ({
  referralCode,
  goalSegmentData,
  referralMessage,
  user_type
}) => {
  const referralInfo = useGetReferralInfo();

  const oneLink = useOneLinkReferral(
    {
      referralCode
    },
    referralMessage?.includes('<referral_link>')
  );
  const copyMessage = useCreateReferralMessage(referralMessage, {
    referralCode,
    referralLink: oneLink
  });

  const [showToast, setShowToast] = useState(false);
  const closeToast = useCallback(() => setShowToast(false), []);

  const copyToClipboard = useCallback(() => {
    navigator.clipboard?.writeText(copyMessage);
    setShowToast(true);
    setTimeout(closeToast, 5000);
  }, [copyMessage, closeToast]);

  const shareLink = useCallback(
    (platform) => {
      if (platform === 'copy') {
        copyToClipboard();
      } else if (navigator.share) {
        navigator.share({
          title: 'Use my referral code',
          text: copyMessage,
          url: oneLink
        });
      } else {
        const shareText = copyMessage.replaceAll('\n\n', '. ');
        switch (platform) {
          case 'facebook':
            socialShare.shareToFB({ url: oneLink, title: copyMessage });
            break;

          case 'twitter':
            socialShare.shareToTwitter({ url: oneLink, text: copyMessage });
            break;

          case 'whatsapp':
            socialShare.shareToWhatsappwWeb({
              url: oneLink,
              text: shareText
            });
            break;

          case 'telegram':
            socialShare.shareToTelegram({ url: oneLink, text: shareText });
            break;

          default:
            copyToClipboard();
            break;
        }
      }
      segment.track(REFER_CODE_SHARED, {
        ...goalSegmentData,
        referrer_uid: referralInfo.meUID,
        referrer_code: referralCode,
        referrer_name: referralInfo.name,
        referrer_goal_name: referralInfo.goalName,
        referrer_goal_uid: referralInfo.goalUID,
        referral_type: user_type,
        sharing_platform: platform
      });
    },
    [
      copyMessage,
      oneLink,
      copyToClipboard,
      referralInfo,
      referralCode,
      user_type,
      goalSegmentData
    ]
  );

  return {
    showToast,
    closeToast,
    shareLink
  };
};

export default useReferralSharing;
